<template>

  <component :is="el" :label="label" :required="required" :size="size" >
    <el-color-picker
    v-model="formData"
    :show-alpha="alpha"
    :placeholder="placeholder"
    :predefine="predefineColors"
    :disabled="disabled"
    @change="updated" />
  </component>

</template>

<script>

export default {
  name: 'color-picker',

  props: {
    label: {
      type: String,
      default: null
    },
    value: {
//      type: String,
      required: true
    },
    alpha: {
      type: Boolean,
      default: false
    },
    predefined: {
      type: Array,
      default: () => [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsv(51, 100, 98)',
        'hsva(120, 40, 94, 0.5)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577'
      ]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default'
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Select Color...'
    },
    helpText: {
      type: String,
      default: null
    },
    noForm: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  },

  data () {
    return {
      el: this.noForm ? 'div' : 'el-form-item',
      formData: this.value,
      predefineColors: this.predefined
    }
  }   // data

}
</script>
